const styles = (theme) => ({
  assetCard: {
    padding: theme.spacing(2),
    border: '1px solid #D9DCDF',
    borderRadius: 8,
  },
  checkbox: {
    [theme.breakpoints.down('sm')]: {
      padding: 0
    }
  }
});

export default styles;